import {
  MailTemplateAdapterInteface,
  ListMailTemplatesInput,
} from 'src/adapter/MailTemplateAdapterInterface';
import {
  MailTemplateCreateAttributes,
  MailTemplateUpdateAttributes,
  MailTemplateGetAttributes,
} from 'src/models/MailTemplateModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosMailTemplateAdapter implements MailTemplateAdapterInteface {
  async listMailTemplates(
    conditions?: ListMailTemplatesInput
  ): Promise<{ total: number; data: MailTemplateGetAttributes[] }> {
    try {
      const res = await api.get('/mail-templates', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getMailTemplate(id: string): Promise<MailTemplateGetAttributes> {
    try {
      const res = await api.get(`/mail-templates/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createMailTemplate(
    attributes: MailTemplateCreateAttributes
  ): Promise<MailTemplateGetAttributes> {
    try {
      const res = await api.post('/mail-templates', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateMailTemplate(
    id: string,
    attributes: MailTemplateUpdateAttributes
  ): Promise<MailTemplateGetAttributes> {
    try {
      const res = await api.put(`/mail-templates/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteMailTemplate(id: string): Promise<boolean> {
    try {
      return await api.delete(`/mail-templates/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
